import { Route, Routes } from "react-router-dom";
import PagesPage from "../../pages/module-pages/pages/PagesPage";
import NewPagePage from "../../pages/module-pages/pages/NewPagePage";
import UpdatePagePage from "../../pages/module-pages/pages/UpdatePagePage";
import PageEditorPage from "../../pages/module-pages/pages/PageEditorPage";


export default function PageNav() {
  return (
    <Routes>
      <Route path="/" element={<PagesPage />} />
      <Route path="/new" element={<NewPagePage />} />
      <Route path="/update" element={<UpdatePagePage />} />
            <Route path="/editor" element={<PageEditorPage />} />

    </Routes>
  );
}
